export default location =>
  ({ room }) =>
    location === null || location === room.facility.sfid;
